import ApiConfig from '../../config/api'

import BaseListModel from './BaseListModel'

export default class UserCertModel extends BaseListModel {
  apiUrl = ApiConfig.api.user.user_cert_list
}

export const userCertStore = new UserCertModel()
